import { styled } from '@mui/material/styles';
import { Button } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';

export const CancelButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(3),
  color: theme.palette.red.main,
  borderColor: theme.palette.red.main,
  '&:hover': {
    borderColor: theme.palette.red.main
  }
}));

export const SaveButton = styled(LoadingButton)(({ theme }) => ({
  marginRight: theme.spacing(3)
}));

export const ChangeDisplayNameButton = styled(Button)(({ theme }) => ({
  marginRight: theme.spacing(3),
  color: theme.palette.primary.main,
  borderColor: theme.palette.primary.main,
  width: '10rem',
  height: '40px'
})); 